// extracted by mini-css-extract-plugin
module.exports = {"header":"LayoutHeaderCommon_header__LCdhc","active":"LayoutHeaderCommon_active__1je2R"};